import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  GalleryCategory,
  GalleryCategoryPayload,
} from "@project/types/gallery";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/gallery-category`;
const SILENT: RequestConfig = { showNotification: false };

class GalleryCategoryService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<GalleryCategory>> =>
    fetchListPage<GalleryCategory>(`${BASE}/`, query);

  get = async (id: number): Promise<GalleryCategory | undefined> => {
    const data = await get<
      ApiItemResponse<GalleryCategory> | GalleryCategory
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  create = async (
    payload: GalleryCategoryPayload
  ): Promise<GalleryCategory> => {
    const data = await post<
      ApiItemResponse<GalleryCategory> | GalleryCategory,
      GalleryCategoryPayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create gallery category.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<GalleryCategoryPayload>
  ): Promise<GalleryCategory | undefined> => {
    const data = await patch<
      ApiItemResponse<GalleryCategory> | GalleryCategory,
      Partial<GalleryCategoryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const galleryCategoryService = new GalleryCategoryService();
